import { TextField, Autocomplete } from "@mui/material";
import type { ModalComponentProps } from "../../types/modal.types";
import ConfirmModal from "./confirm.modal";
import React from "react";

interface SelectFieldProps extends ModalComponentProps {
  menuItems: { value: string | number; label: string }[];
  value: string | number;
  label: string;
  title: string;
  click?: (value: string | number) => void;
}

export default function SelectFieldModal(props: SelectFieldProps) {
  const { id, onClose, menuItems, value, label, click, title } = props;

  const [selectedValue, setSelectedValue] = React.useState<string | number>(value);

  const handleValueChange = (newValue: string | number) => {
    setSelectedValue(newValue);
  };

  return (
    <ConfirmModal
      id={id}
      onClose={onClose}
      title={title}
      rightButton={{
        title: "저장",
        onClick: () => {
          click?.(selectedValue);
          onClose?.();
        },
      }}
    >
      <section className="mt-4">

        <Autocomplete
          id="common-autocomplete"
          fullWidth
          options={menuItems || []}
          getOptionLabel={(option) => {
            if (typeof option === 'string') return option;
            return option.label || "";
          }}
          value={menuItems.find((item) => item.value === selectedValue) || null}

          onChange={(_, newValue) => {
            handleValueChange(newValue?.value || "");
          }}

          disablePortal
          slotProps={{
            popper: { sx: { zIndex: 9999 } }
          }}

          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              placeholder={`${label}`}
              InputLabelProps={{
                ...params.InputLabelProps,
                shrink: true,
              }}
            />
          )}
        />
      </section>
    </ConfirmModal>
  );

}